export default function StarIcon({
  height = 16,
  width = 16,
  className,
}: {
  height?: number;
  width?: number;
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 12"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      role="img"
      className={className}
    >
      <path
        d="M2.795 12L3.77 7.56316L0.5 4.57895L4.82 4.18421L6.5 0L8.18 4.18421L12.5 4.57895L9.23 7.56316L10.205 12L6.5 9.64737L2.795 12Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}
